import { useEffect, useState } from 'react';

export default function NewsHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <section className="relative w-full h-[70vh] min-h-[500px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=abstract%20luxury%20world%20map%20made%20of%20golden%20light%20particles%20and%20soft%20bokeh%20on%20dark%20background%20elegant%20minimalist%20design%20warm%20amber%20tones%20global%20business%20expansion%20concept&width=1400&height=700&seq=news-hero&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <div className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6">
            Noticias
          </h1>
          <div className="w-16 h-px bg-white/40 mx-auto mb-6" />
          <p className={`text-white/80 text-sm md:text-base max-w-2xl mx-auto leading-relaxed transition-all duration-1000 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            Desde nuestro inicio en 2016 hemos expandido nuestra presencia a más de 8 países de Latinoamérica, llevando insumos de perfumería fina a cada rincón de la región.
          </p>
        </div>
      </div>
    </section>
  );
}